module.exports = __webpack_public_path__ + "static/img/none.6583e329.svg";